import CcxContextualMenuIcon from '../ccx/icons/CcxContextualMenuIcon';
import { Button, Dropdown, Menu } from 'antd';
import { EditOutlined } from '@severalnines/frontend_hub/libs/icons';
import DeploymentsItem from '../../types/DeploymentsItem';
import ButtonWithOverlayDialog from '../common/ButtonWithOverlayDialog';
import BackupsScheduleEditDrawer from './BackupsScheduleEditDrawer';
import BackupSchedule from '../../types/BackupSchedule';
import BackupsScheduleSwitchButton from './BackupsScheduleSwitchButton';
import { Draft } from '@reduxjs/toolkit';
import BackupsScheduleBinlogSwitchButton from './BackupsScheduleBinlogSwitch';

type BackupsScheduleActionsMenuProps = {
    disabled?: boolean;
    deployment: Draft<DeploymentsItem>;
    schedule: BackupSchedule;
    onActionPerformed?: () => void;
};
export default function BackupsScheduleActionsMenu({
    disabled,
    deployment,
    schedule,
    onActionPerformed,
}: BackupsScheduleActionsMenuProps) {
    const menu = (
        <Menu>
            {schedule.isBinLog() && (
                <Menu.Item
                    key="binlogpause"
                    data-testid="pause-button"
                    disabled={disabled}
                >
                    <BackupsScheduleBinlogSwitchButton
                        stretchedClick={true}
                        deployment={deployment}
                        schedule={schedule}
                        onSuccess={onActionPerformed}
                    />
                </Menu.Item>
            )}
            {!schedule.isBinLog() && (
                <Menu.Item key="pause" data-testid="pause-button">
                    <BackupsScheduleSwitchButton
                        stretchedClick={true}
                        deployment={deployment}
                        schedule={schedule}
                        onSuccess={onActionPerformed}
                    />
                </Menu.Item>
            )}
            {!schedule.isBinLog() && (
                <Menu.Item key="edit" data-testid="edit-button">
                    <ButtonWithOverlayDialog
                        stretchedClick={true}
                        data-testid="edit-schedule-button"
                        button={
                            <Button
                                role="button"
                                icon={<EditOutlined />}
                                type={'text'}
                            >
                                Edit
                            </Button>
                        }
                        overlay={
                            <BackupsScheduleEditDrawer
                                deployment={deployment}
                                schedule={schedule}
                                onSuccess={onActionPerformed}
                            />
                        }
                    />
                </Menu.Item>
            )}
        </Menu>
    );
    // @todo create common component for action menu and maybe reuse ActionMenu from bar-frontend-components
    return (
        <Dropdown
            overlay={menu}
            disabled={disabled}
            placement="bottomRight"
            trigger={['click']}
        >
            <Button icon={<CcxContextualMenuIcon />} />
        </Dropdown>
    );
}
